import React, { lazy, Suspense, useContext } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { Text, UiWrapper, View } from '@coinscrap/webapp-core';

import TaxRegimeModal from 'components/TaxRegimeModal/TaxRegimeModal';

import logoAllianz from 'assets/images/logos/Allianz_negativo.svg';
import logoBmwGroup from 'assets/images/logos/BMW_Group_White.svg';

import { AgentContext } from '../../../contexts/agent';
import * as S from './styles';

const TermsModal = lazy(() => import('components/TermsModal/TermsModal'));

const Footer = ({ children }) => {
	const { openModal } = UiWrapper.use();
	const { agent } = useContext(AgentContext);

	return (
		<View
			footerSt
			style={isMobile ? { paddingBottom: agent.delioEnabled ? '4rem' : '.3rem' } : {}}
		>
			{/* {children} */}
			<View footerInnerSt style={{ gap: '0.5rem' }}>
				<View rowSt justifyStartSt style={{ width: 'fit-content', gap: '1rem' }}>
					<View
						rowSt
						justifyStartSt
						cursorPointerSt
						style={{ width: 'fit-content' }}
						onClick={() => {
							openModal(
								(close) => (
									<Suspense fallback={<div>Loading...</div>}>
										<TermsModal isOpen={true} onClose={close} />
									</Suspense>
								),
								{
									mode: 'old',
									key: 'modal-legalAdvice',
								},
							);
						}}
					>
						<Text style={{ fontSize: 14, color: CONFIG.colors.white }}>
							Aviso legal y privacidad
						</Text>
					</View>
					<View
						rowSt
						justifyStartSt
						cursorPointerSt
						style={{ width: 'fit-content' }}
						onClick={() => {
							openModal((close) => <TaxRegimeModal isOpen={true} onClose={close} />, {
								mode: 'old',
								key: 'modal-fiscal',
							});
						}}
					>
						<Text style={{ fontSize: 14, color: CONFIG.colors.white }}>
							Régimen fiscal aplicable
						</Text>
					</View>
				</View>
				{(agent.identifier === 'allianz' || agent.identifier === 'rastreator') && (
					<S.Logo alt="Logo Allianz" src={logoAllianz} />
				)}
				{agent.identifier === 'bmw' && <S.Logo alt="Logo BMW" src={logoBmwGroup} />}
			</View>
		</View>
	);
};

export default Footer;
